import { SnippetsType } from '@chamn/model';

export const snippets: SnippetsType[] = [
  {
    title: '基础按钮',
    snapshot:
      'https://alifd.oss-cn-hangzhou.aliyuncs.com/fusion-cool/icons/icon-light/ic_light_button.png',
    description:
      '我是 antd 的 Button 组件,我是 antd 的 Button 组件,我是 antd 的 Button 组件,我是 antd 的 Button 组件,我是 antd 的 Button 组件,我是 antd 的 Button 组件,我是 antd 的 Button 组件,我是 antd 的 Button 组件,我是 antd 的 Button 组件',
    schema: {
      props: {
        type: 'primary',
      },
      children: ['I am a Button'],
    },
  },
];
